<template>
  <div class="row">
    <legend class="col-12 col-form-label text-primary pt-0 mb-3">
      <h5 v-html="$store.getters.getTag('5.7')"></h5>
    </legend>

    <p class="col-12" v-html="$store.getters.getTag('5.7.1')"></p>

    <div class="col-12">
      <app-note
        class="mb-primary"
        title="Nota"
        content-type="html"
        :notes="[
          $store.getters.getTag('5.I.1')
        ]"
      />
    </div>

    <form-v2-oeyc-annexed-list class="col-12" />
  </div>
</template>

<script>
export default {
  computed: {
    activity() {
      return this.$store.state.accreditation.app != null
        ? this.$store.state.accreditation.app.accreditation_activity.code
        : null;
    },

    disabled() {
      return (
        this.$store.state.accreditation.app != null &&
        this.$store.state.accreditation.app.status.code != "100"
      );
    },
  },
  created() {
  },
};
</script>